// extracted by mini-css-extract-plugin
module.exports = {"loginContainer":"Login_loginContainer__3slNW","login":"Login_login__3Lkjs","imgdivd":"Login_imgdivd__35sUO","btnsubt":"Login_btnsubt__3zF5d"};